import {formatCountWithMax} from '@toolify/client/src/modules/ui/functions/formatCountWithMax'
import {NotificationBadgeMax} from '@toolify/client/src/modules/notifications/constants/NotificationBadgeMax'

export function formatNotificationCount(count: number): string {
  return formatCountWithMax(count, NotificationBadgeMax)
}
